import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_LOW, DROP_COMMAND } from 'lexical';
import { useEffect } from 'react';
import { isImageFile } from '@/components/AttachmentFile/utils';

type FileDragDropPluginProps = {
  onSelectFiles: (files: File[]) => void;
};

export default function FileDragDropPlugin({
  onSelectFiles,
}: FileDragDropPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand<DragEvent>(
      DROP_COMMAND,
      (dragEvent) => {
        if (!(dragEvent instanceof DragEvent)) {
          return false;
        }

        const dt = dragEvent.dataTransfer;
        if (dt && dt.files.length > 0) {
          const files = Array.from(dt.files);

          // 이미지가 아닌 파일만 필터링
          const nonImageFiles = files.filter((file) => !isImageFile(file.name));

          // 이미지는 Lexical 자동 처리 + useImageUpload 크기 검증
          if (nonImageFiles.length > 0) {
            dragEvent.preventDefault();
            onSelectFiles(nonImageFiles);
            return true;
          }
        }
        return false;
      },
      COMMAND_PRIORITY_LOW,
    );
  }, [editor, onSelectFiles]);

  return null;
}
